/* =========================================================
   POPUP DE ACTIVIDAD RECIENTE — SHOPIFY / SHRINE PRO
   Archivo: assets/recent-purchase.js
   ========================================================= */

(function () {
  "use strict";

  function initializeRecentPurchasePopup() {
    const popup = document.getElementById("recent-purchase-popup");

    if (!popup || popup.dataset.initialized === "true") {
      return;
    }

    popup.dataset.initialized = "true";

    const dataElement = document.getElementById("recent-purchase-data");
    const closeButton = popup.querySelector(".rp-close");
    const customerName = popup.querySelector(".rp-customer-name");
    const locationElement = popup.querySelector(".rp-location");
    const productTitle = popup.querySelector(".rp-product-title");
    const timeElement = popup.querySelector(".rp-time");
    const productImage = popup.querySelector(".rp-product-image");

    if (!dataElement) {
      console.warn("Recent Purchase: no se encontraron los datos.");
      return;
    }

    let popupData;

    try {
      popupData = JSON.parse(dataElement.textContent);
    } catch (error) {
      console.error("Recent Purchase: datos JSON incorrectos.", error);
      return;
    }

    const customers = Array.isArray(popupData.customers)
      ? popupData.customers
      : [];

    if (customers.length === 0) {
      return;
    }

    const settings = popupData.settings || {};
    const product = popupData.product || {};

    const initialDelay = Number(settings.initialDelay) || 5000;
    const visibleTime = Number(settings.visibleTime) || 6000;
    const intervalTime = Number(settings.intervalTime) || 13000;

    let currentIndex = -1;
    let initialTimer = null;
    let hideTimer = null;
    let nextTimer = null;
    let dismissed = false;

    function getRandomIndex() {
      if (customers.length === 1) {
        return 0;
      }

      let newIndex = currentIndex;

      while (newIndex === currentIndex) {
        newIndex = Math.floor(Math.random() * customers.length);
      }

      return newIndex;
    }

    function updatePopup(customer) {
      if (!customer) {
        return;
      }

      customerName.textContent = customer.name || "Cliente";
      locationElement.textContent = customer.location || "Perú";
      const timeOptions = [
  "hace 3 minutos",
  "hace 7 minutos",
  "hace 12 minutos",
  "hace 18 minutos",
  "hace 26 minutos",
  "hace 35 minutos",
  "hace 48 minutos",
  "hace 1 hora",
  "hace 2 horas"
];

const randomTime =
  timeOptions[Math.floor(Math.random() * timeOptions.length)];

timeElement.textContent = randomTime;
        

      productTitle.textContent =
        product.title || "Producto de la tienda";

      if (product.image) {
        productImage.src = product.image;
        productImage.alt =
          product.title || "Producto comprado";
      } else {
        productImage.removeAttribute("src");
        productImage.alt = "";
      }
    }

    function hidePopup() {
      popup.classList.remove("rp-visible");

      hideTimer = window.setTimeout(function () {
        if (!popup.classList.contains("rp-visible")) {
          popup.setAttribute("aria-hidden", "true");
        }
      }, 400);
    }

    function scheduleNextPopup() {
      if (dismissed) {
        return;
      }

      const waitingTime = Math.max(
        intervalTime - visibleTime,
        1500
      );

      nextTimer = window.setTimeout(showPopup, waitingTime);
    }

    function showPopup() {
      if (dismissed) {
        return;
      }

      currentIndex = getRandomIndex();
      updatePopup(customers[currentIndex]);

      popup.setAttribute("aria-hidden", "false");

      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          popup.classList.add("rp-visible");
        });
      });

      window.clearTimeout(hideTimer);
      window.clearTimeout(nextTimer);

      hideTimer = window.setTimeout(function () {
        hidePopup();
        scheduleNextPopup();
      }, visibleTime);
    }

    function dismissPopup() {
      dismissed = true;

      window.clearTimeout(initialTimer);
      window.clearTimeout(hideTimer);
      window.clearTimeout(nextTimer);

      popup.classList.remove("rp-visible");
      popup.classList.add("rp-dismissed");
      popup.setAttribute("aria-hidden", "true");

      try {
        sessionStorage.setItem(
          "recentPurchasePopupClosed",
          "true"
        );
      } catch (error) {
        // El navegador puede bloquear sessionStorage.
      }
    }

    try {
      if (
        sessionStorage.getItem(
          "recentPurchasePopupClosed"
        ) === "true"
      ) {
        dismissed = true;
        popup.classList.add("rp-dismissed");
        return;
      }
    } catch (error) {
      // Continúa aunque sessionStorage esté bloqueado.
    }

    if (closeButton) {
      closeButton.addEventListener("click", dismissPopup);
    }

    initialTimer = window.setTimeout(
      showPopup,
      initialDelay
    );
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      initializeRecentPurchasePopup
    );
  } else {
    initializeRecentPurchasePopup();
  }

  document.addEventListener(
    "shopify:section:load",
    initializeRecentPurchasePopup
  );
})();